import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Overlay } from 'ui';
import { v4 as uuidv4 } from 'uuid';
import './index.scss';

class StateRing extends Component {
  static propTypes = {
    states: PropTypes.objectOf(
      PropTypes.shape({
        tooltip: PropTypes.string,
        className: PropTypes.string,
        icon: PropTypes.string,
        preset: PropTypes.oneOf(['danger', 'warning', 'info', 'success']),
      })
    ),
    defaultState: PropTypes.string,
    state: PropTypes.string,
    radius: PropTypes.number,
    stroke: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.target = createRef();
  }

  uniqueId = uuidv4();

  static defaultProps = {
    states: {},
    radius: 25,
    stroke: 3,
  };

  render() {
    const state =
      this.props.states[this.props.state || this.props.defaultState];
    const normalizedRadius = this.props.radius - this.props.stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const style = {
      height: this.props.radius * 2,
    };

    return (
      <div
        id={`StateRing-${this.uniqueId}`}
        className={`StateRing ${
          state.preset ? `StateRing-${state.preset}` : ''
        } ${state.className ? state.className : ''}`}
        style={style}
        ref={this.target}
        onMouseEnter={() => this.setState({ show: true })}
        onMouseLeave={() => this.setState({ show: false })}
      >
        {state.icon ? (
          <div
            className="StateRing-icon"
            style={{ height: this.props.radius * 2 }}
          >
            <i className={state.icon}></i>
          </div>
        ) : null}
        <svg height={this.props.radius * 2} width={this.props.radius * 2}>
          <circle
            cx={this.props.radius}
            cy={this.props.radius}
            r={normalizedRadius}
            fill="none"
            stroke="#f1f1f1"
            strokeWidth={this.props.stroke}
          />
          <circle
            fill="transparent"
            strokeWidth={this.props.stroke}
            strokeDasharray={`${circumference} ${circumference}`}
            r={normalizedRadius}
            cx={this.props.radius}
            cy={this.props.radius}
          />
        </svg>
        {state.tooltip ? (
          <Overlay
            target={this.target.current}
            show={this.state.show}
            placement="bottom"
          >
            {(props) => <Tooltip {...props}>{state.tooltip}</Tooltip>}
          </Overlay>
        ) : null}
      </div>
    );
  }
}

export default StateRing;
